import { useState, useEffect, useRef } from 'react'
import { formatLanguage, getVoiceName } from "../../utils/voiceUtils";

function AvatarCard({ avatar, onCopyAssetId }) {
    const [showVideo, setShowVideo] = useState(false);

    try {
        const getVideoUrl = () => {
            // For demo purposes, use a sample video URL
            // In production, this would come from avatar.videoUrl or similar field
            return avatar.video_url || "https://resource.trickle.so/video/sample-avatar-video.mp4";
        };

        const toggleVideo = () => {
            setShowVideo(!showVideo);
        };

        const handleThumbnailClick = () => {
            if (avatar.status != 'completed') {
                window.dispatchEvent(new CustomEvent('showMessage', {
                    detail: {
                        text: avatar.status == 'error' ? '創建失敗，無法播放' : '視頻正在製作中，請稍後再試',
                        type: avatar.status == 'error' ? 'error' : 'info'
                    }
                }));
                return;
            }
            setShowVideo(true);
        };

        return (
            <div 
                key={avatar.id}
                className="bg-white rounded-lg border border-gray-200 p-4 shadow-sm"
                data-name={`avatar-${avatar.id}`}
            >
                <div className="flex justify-between items-start mb-2">
                    <div>
                        <h3 className="font-medium">{avatar.video_id}</h3>
                        <div className="text-xs text-gray-500">
                            {new Date(avatar.create_time).toLocaleString('zh-TW')}
                        </div>
                    </div>
                    <span 
                        title={avatar.status=='error' ? avatar.result : ''} 
                        className={`px-2 py-1 ${avatar.status === 'completed' ? 'bg-green-100 text-green-800' : (avatar.status=='error' ? 'bg-red-600 text-white' : 'bg-gray-400 text-white')} text-xs rounded`}
                    >{avatar.status || 'completed'}</span>
                </div>

                <div className="mt-3 mb-3 relative bg-black rounded overflow-hidden">
                    {showVideo ? (
                        <div className="relative pt-[56.25%]">
                            <video 
                                className="absolute inset-0 w-full h-full"
                                controls
                                autoPlay
                                src={getVideoUrl()}
                                data-name="avatar-video"
                            >
                                您的瀏覽器不支持影片播放
                            </video>
                        </div>
                    ) : (
                        <div 
                            className="relative pt-[56.25%] cursor-pointer group"
                            onClick={handleThumbnailClick}
                            data-name="video-thumbnail-container"
                        >
                            { avatar.video_img && <img 
                                src={avatar.video_img} 
                                alt="影片縮略圖"
                                className="absolute inset-0 w-full h-full object-cover"
                                data-name="video-thumbnail"
                            /> }
                            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 opacity-0 group-hover:opacity-100 transition-opacity">
                                <div className="w-16 h-16 rounded-full bg-black bg-opacity-50 flex items-center justify-center">
                                    <i className="fas fa-play text-white text-2xl"></i>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div className="text-sm text-gray-600 mt-2">
                    <div><span className="font-medium">畫質:</span> {avatar.size}</div>
                    <div><span className="font-medium">語音:</span> {getVoiceName(avatar.voice_id)}</div>
                    <div><span className="font-medium">語言:</span> {formatLanguage(avatar.language)}</div>
                </div>
                <div className="flex justify-between items-center mt-3">
                    <button
                        onClick={() => onCopyAssetId(avatar.video_id)}
                        className="text-sm px-3 py-1 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                        data-name={`copy-asset-id-${avatar.id}`}
                    >
                        <i className="fas fa-copy mr-1"></i>
                        複製 Asset ID
                    </button>
                    <a 
                        href={"https://app.heygen.com/videos/" + avatar.video_id} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-sm text-purple-600 hover:text-purple-800"
                        data-name="open-heygen-link"
                    >
                        <i className="fas fa-external-link-alt mr-1"></i>
                        前往 HeyGen
                    </a>
                </div>
            </div>
        );
    } catch (error) {
        console.error('AvatarCard component error:', error);
        reportError(error);
        return null;
    }
}

export default AvatarCard;